<template>
  <div class="container ptb-100">
    <div class="row gx-xxl-5">
      <div class="col-xl-8 col-lg-7">
        <div class="blog-desc">
          <div class="single-img mb-30">
            <img src="../../assets/img/blog/single-blog-1.webp" alt="Image" />
          </div>
          <ul class="blog-metainfo list-style">
            <li class="position-relative d-inline-block">
              <router-link to="/posts-by-author">Admin</router-link>
            </li>
            <li class="position-relative d-inline-block">
              <span>22 November, 2023</span>
            </li>
            <li class="position-relative d-inline-block">
              <a href="#cmt-form">02 Comments</a>
            </li>
          </ul>
          <div class="single-para">
            <h1>How and why you should use google Ads in your article</h1>
            <p>
              Go after leads more effectively, find out the status other sales
              cycle, and optimize efforts. Automate so that a most processes
              with powerful tools for maximum for this is a text in this season
              efficiency.
            </p>
            <p>
              Nowadays, technology has become super advanced. Even normal people
              are getting themselves enrolled in coding and programming and
              creating applications on their own. An app developer earns a hefty
              amount as well, and this, if seen from a business point of view,
              has a lot of scope to be a million-dollar business in the future.
            </p>
          </div>
          <div class="single-img mb-50">
            <img src="../../assets/img/blog/single-blog-2.webp" alt="Image" />
          </div>
          <div class="single-para">
            <h4>Tips To Boost Sales</h4>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur,
              et nobis accusantium ratione quibusdam, error quasi veritatis
              obcaecati hic quo aspernatur nam dolore totam modi eius ipsa sunt
              blanditiis tempora lorem ipsum dolor sit amet consectetur
              adipisicing elit. Suscipit, fuga..
            </p>
            <div class="wp-blockquote bg-magnolia round-10 br-one">
              <p class="mb-20">
                “Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been is the industry's
                standard dummy text ever since the 1500s, when an unknown.”
              </p>
              <h6>John Smith</h6>
            </div>
          </div>
          <div class="single-para">
            <h4>03 Tips To Put Your Creativity On The Development?</h4>
            <p>
              Go after leads more effectively, find out the status of the sales
              cycle, and optimize efforts. Automate most process with powerful
              tools for maximum for this is a text in this season.
            </p>
            <ul class="list-style mb-30">
              <li class="text-title position-relative fw-medium mb-10">
                <span class="text-optional me-2">01.</span>NYmag only uses the
                most trending layouts and mockups for its eye caching
              </li>
              <li class="text-title position-relative fw-medium mb-10">
                <span class="text-optional me-2">02.</span>Product marketing to
                targeted customers for business support system needed
              </li>
              <li class="text-title position-relative fw-medium mb-10">
                <span class="text-optional me-2">03.</span>Downloadable
                lectures, code and design assets for all projects
              </li>
            </ul>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
              consectetur dolorum nobis dolores pariatur! Autem delectus cum
              consequatur id dolore voluptatem odit ea! Incidunt sed ad, modi
              quos a Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Saepe, repudiandae
            </p>
          </div>
          <div
            class="post-meta-option mb-50 d-md-flex justify-content-between align-items-center"
          >
            <div class="post-tags d-flex align-items-center">
              <span class="f-secondary fs-20 fw-medium text-title me-2">
                Tags:
              </span>
              <ul class="tag-list list-style">
                <li class="mt-0">
                  <router-link to="/posts-by-tag">Business</router-link>
                </li>
                <li class="mt-0">
                  <router-link to="/posts-by-tag">Marketing</router-link>
                </li>
              </ul>
            </div>
            <div class="post-share d-flex align-items-center">
              <span class="f-secondary fs-20 fw-medium text-title me-2">
                Share:
              </span>
              <ul class="social-profile list-style d-flex align-items-center">
                <li>
                  <a href="https://www.fb.com" target="_blank">
                    <i class="ri-facebook-fill"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.pinterest.com" target="_blank">
                    <i class="ri-pinterest-line"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com" target="_blank">
                    <i class="ri-instagram-line"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com" target="_blank">
                    <i class="ri-twitter-x-fill"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="comment-box bg-magnolia br-one round-10 mb-45">
            <h3 class="fs-34">02 Comments</h3>
            <div class="comment-item-wrap">
              <div class="comment-item d-flex">
                <div class="comment-author round-circle">
                  <img
                    src="../../assets/img/blog/avatar-1.webp"
                    alt="Image"
                    class="round-circle"
                  />
                </div>
                <div class="comment-info">
                  <div class="row align-items-center">
                    <div class="col-md-9 order-md-1 order-1">
                      <h5>Amenda Smith</h5>
                      <span>2 Days ago</span>
                    </div>
                    <div class="col-md-3 order-md-2 order-3 text-md-end">
                      <a href="#cmt-form" class="reply-btn">Reply</a>
                    </div>
                    <div class="col-md-12 order-md-3 order-2">
                      <p>
                        he design is simple and elegant. The customer support on
                        this product is also amazing. I would highly recommend
                        you to purchase templates from the Prag.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="comment-item d-flex reply">
                <div class="comment-author round-circle">
                  <img
                    src="../../assets/img/blog/avatar-2.webp"
                    alt="Image"
                    class="round-circle"
                  />
                </div>
                <div class="comment-info">
                  <div class="row align-items-center">
                    <div class="col-md-9 order-md-1 order-1">
                      <h5 class="fs-20">Julias Hook</h5>
                      <span>4 Days ago</span>
                    </div>
                    <div class="col-md-3 order-md-2 order-3 text-md-end">
                      <a href="#cmt-form" class="reply-btn">Reply</a>
                    </div>
                    <div class="col-md-12 order-md-3 order-2">
                      <p>
                        he design is simple and elegant. The customer support on
                        this product is also amazing. I would highly recommend
                        you to purchase templates from the Prag.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="comment-item d-flex">
                <div class="comment-author round-circle">
                  <img
                    src="../../assets/img/blog/avatar-3.webp"
                    alt="Image"
                    class="round-circle"
                  />
                </div>
                <div class="comment-info">
                  <div class="row align-items-center">
                    <div class="col-md-9 order-md-1 order-1">
                      <h5 class="fs-20">Tony Stark</h5>
                      <span>3 Days ago</span>
                    </div>
                    <div class="col-md-3 order-md-2 order-3 text-md-end">
                      <a href="#cmt-form" class="reply-btn">Reply</a>
                    </div>
                    <div class="col-md-12 order-md-3 order-2">
                      <p>
                        he design is simple and elegant. The customer support on
                        this product is also amazing. I would highly recommend
                        you to purchase templates from the Prag.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="comment-form">
            <h3 class="fs-34">Leave A Comment</h3>
            <form action="#" id="cmt-form">
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-25">
                    <textarea
                      name=""
                      id=""
                      cols="30"
                      rows="10"
                      placeholder="Your Comment here"
                      class="bg-white w-100 round-6 h-180 resize-0"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-25">
                    <input
                      type="text"
                      placeholder="Your name"
                      class="bg-white w-100 round-6"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-25">
                    <input
                      type="email"
                      placeholder="Your email"
                      class="bg-white w-100 round-6"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check checkbox mb-25">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_2"
                    />
                    <label class="form-check-label" for="test_2">
                      Save my name, email, and website in this browser for the
                      next time I comment.
                    </label>
                  </div>
                </div>
                <div class="col-12">
                  <button class="btn style-one">Post A Comment</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-5">
        <SidebarWidget />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "BlogDetailsRightSidebar",
  components: {
    SidebarWidget,
  },
});
</script>